export const PREMIUM_TYPES = [
  {
    id: 1,
    title: "[유리 성벽의 수호자] (The Glass Fortress)",
    combination: [
      { qId: 3, options: [2, 3] }, // C, D
      { qId: 7, options: [1] },    // B
      { qId: 29, options: [3] }    // D
    ],
    psychology:
      "겉으로는 매우 침착하고 흔들림이 없어 보이지만, 내면에서는 신뢰와 원칙을 무엇보다 중요하게 여기는 타입입니다.",
    love:
      "평소에는 쿨하지만, 신뢰가 무너지면 마음이 완전히 닫힙니다. 상대는 큰 문제가 아니라고 생각했던 일이 당신에게는 결정적 균열이었음을 뒤늦게 알게 됩니다."
  },
  {
    id: 2,
    title: "[가스등 아래의 엔진] (The Martyr Engine)",
    combination: [
      { qId: 11, options: [3] },   // D
      { qId: 13, options: [3] },   // D
      { qId: 26, options: [2, 3] } // C, D
    ],
    psychology:
      "타인의 감정에 깊이 공명하며, 상대를 지켜야 한다는 책임감이 강하게 작동하는 타입입니다.",
    love:
      "연인이 힘들어하면 본인 책임처럼 느끼며 과도하게 헌신합니다. 하지만 스스로를 소모하다가 어느 순간 지쳐 무너질 수 있습니다."
  },
  {
    id: 3,
    title: "[차가운 통찰의 저격수] (The Logical Sniper)",
    combination: [
      { qId: 14, options: [2, 3] }, // C, D
      { qId: 15, options: [0] },    // A
      { qId: 18, options: [2] }     // C
    ],
    psychology:
      "상대의 의도와 맥락을 빠르게 파악하며, 감정보다는 논리로 상황을 정리하려는 성향이 강합니다.",
    love:
      "갈등 상황에서 감정보다 팩트와 모순을 먼저 짚습니다. 정확하지만, 상대는 공감보다 평가받는 느낌을 받을 수 있습니다."
  },
  {
    id: 4,
    title: "[방관하는 쾌락주의자] (The Floating Hedonist)",
    combination: [
      { qId: 16, options: [1] }, // B
      { qId: 21, options: [0] }, // A
      { qId: 30, options: [1] }  // B
    ],
    psychology:
      "타인의 문제에 깊이 개입하기보다, 자신의 현재 컨디션과 즐거움을 우선시하는 성향입니다.",
    love:
      "갈등이 생겨도 크게 흔들리지 않지만, 문제를 깊게 해결하려는 동기가 약해 관계가 얕게 흘러갈 수 있습니다."
  },
  {
    id: 5,
    title: "[브레이크 없는 전차] (The Unstoppable Tank)",
    combination: [
      { qId: 4, options: [0] },  // A
      { qId: 10, options: [0] }, // A
      { qId: 28, options: [3] }  // D
    ],
    psychology:
      "압박 상황에서 빠르게 반응하고 자신의 주장을 밀어붙이는 추진력이 강합니다.",
    love:
      "열정적이고 확신이 강하지만, 상대의 속도와 감정을 고려하지 않으면 관계가 일방적으로 흘러갈 수 있습니다."
  },
  {
    id: 6,
    title: "[사회적 가면의 지휘자] (The Social Conductor)",
    combination: [
      { qId: 12, options: [3] }, // D
      { qId: 20, options: [1] }, // B
      { qId: 22, options: [1] }  // B
    ],
    psychology:
      "주변 분위기를 읽는 능력이 뛰어나며, 사회적으로 매끄럽게 행동하는 감각이 발달해 있습니다.",
    love:
      "공적인 자리에서는 매력적이지만, 연인은 사적인 공간에서 더 많은 정서적 집중을 원할 수 있습니다."
  },
  {
    id: 7,
    title: "[동굴 속의 고독한 전략가] (The Hermit Strategist)",
    combination: [
      { qId: 1, options: [2] }, // C
      { qId: 5, options: [0] }, // A
      { qId: 9, options: [2] }  // C
    ],
    psychology:
      "위기 상황에서 감정을 즉각 드러내기보다 혼자 정리하고 복구하는 타입입니다.",
    love:
      "갈등 후 생각할 시간이 필요합니다. 이는 회피가 아니라 정리 과정이지만, 설명이 없으면 오해를 부를 수 있습니다."
  },
  {
    id: 8,
    title: "[불안한 로맨틱 도파민] (The Anxious Romantic)",
    combination: [
      { qId: 2, options: [0, 1] },  // A, B
      { qId: 7, options: [1] },     // B
      { qId: 24, options: [0, 1] }  // A, B
    ],
    psychology:
      "감정 자극에 민감하고, 애정 신호에 빠르게 반응하는 몰입형 타입입니다.",
    love:
      "사랑할 때 매우 열정적이지만, 작은 변화에도 쉽게 불안해질 수 있어 감정 기복이 큽니다."
  },
  {
    id: 9,
    title: "[원칙주의적 결벽주의자] (The Ethical Pharisee)",
    combination: [
      { qId: 22, options: [3] }, // D
      { qId: 25, options: [3] }, // D
      { qId: 27, options: [3] }  // D
    ],
    psychology:
      "스스로에게 매우 엄격하며, 도덕적 기준을 쉽게 타협하지 않는 타입입니다.",
    love:
      "연인의 사소한 무례나 기준 위반에도 마음이 빠르게 식을 수 있습니다. 사랑보다 신뢰와 기준이 먼저 작동합니다."
  },
  {
    id: 10,
    title: "[정적 속의 관찰자] (The Silent Profiler)",
    combination: [
      { qId: 8, options: [2] },  // C
      { qId: 14, options: [3] }, // D
      { qId: 18, options: [3] }  // D
    ],
    psychology:
      "겉으로는 조용하지만, 내부에서는 상대의 말과 행동을 세밀하게 관찰하고 분석합니다.",
    love:
      "의심이 생기면 바로 표현하기보다 확신이 설 때까지 지켜보는 편입니다. 침착하지만 상대는 압박을 느낄 수 있습니다."
  },
  {
    id: 11,
    title: "[자기 파괴적 완벽주의] (The Self-Destructive Perfectionist)",
    combination: [
      { qId: 3, options: [1] },     // B
      { qId: 23, options: [2, 3] }, // C, D
      { qId: 29, options: [3] }     // D
    ],
    psychology:
      "자신에게 매우 높은 기준을 적용하며, 문제가 생기면 외부보다 자신을 먼저 돌아보는 성향입니다.",
    love:
      "관계가 흔들리면 스스로를 자책합니다. 배려 깊지만, 자존감이 소모되기 쉬운 타입입니다."
  },
  {
    id: 12,
    title: "[유연한 기회주의자] (The Flexible Opportunist)",
    combination: [
      { qId: 25, options: [0] },    // A
      { qId: 28, options: [0] },    // A
      { qId: 29, options: [0, 1] }  // A, B
    ],
    psychology:
      "고정된 틀보다 상황에 맞는 선택을 중시하는 유연한 현실주의자입니다.",
    love:
      "관계의 형태에 대해 열려 있으며, 전통적인 연애 공식에 얽매이지 않습니다. 하지만 안정감을 중요시하는 상대와는 충돌할 수 있습니다."
  }
];

// Helper to determine the best matching type for a user
export const getPremiumAnalysis = (userAnswers) => {
  if (!userAnswers) return null;

  let bestMatch = null;
  let maxScore = -1;

  PREMIUM_TYPES.forEach((type) => {
    let score = 0;

    type.combination.forEach((cond) => {
      const userAns = userAnswers[cond.qId];
      if (userAns !== undefined && cond.options.includes(userAns)) score++;
    });

    if (score > maxScore) {
      maxScore = score;
      bestMatch = type;
    }
  });

  return { type: bestMatch, matchScore: maxScore };
};
